<template>
  <div class="template-info">
    <block-title
      class="block-title"
      title="自定义模板信息"
    >
      <div slot="icon-right" class="block-icon-right" >
        <span>默认模板</span>
        <a-switch v-model="form.isDefault" checked-children="开" un-checked-children="关" />
      </div>
      <a-form-model
        ref="infoForm"
        class="form-content"
        :model="form"
        :label-col="{ span: 3 }" 
        :wrapper-col="{ span: 7 }"
        :rules="rules"
      >
        <a-form-model-item :colon="false" label="模板名称" prop="templateName">
          <a-input
            v-model.trim="form.templateName"
            :max-length="30"
            placeholder="请输入模板名称"
            @change="changeInfo"
          />
        </a-form-model-item>
        <a-form-model-item :colon="false" class="form-nomal" label="模板表头所在行" prop="headRow">
          <a-select
            v-model="form.headRow"
            @change="changeHeadRow"
          >
            <a-select-option
              v-for="item in headRowList"
              :key="item.dictionaryCode"
              :value="item.dictionaryCode"
            >
              {{item.dictionaryName}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </block-title>
  </div>
</template>

<script>
import baseApi from '@/api/base.js'
import BlockTitle from '@/components/panel/BlockTitle.vue'

export default {
  name: 'TemplateInfo',
  components: {
    BlockTitle
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      rules: {
        templateName: [
          { required: true, message: '请输入模板名称', trigger: 'change' },
          { validator: (rule, value, callback) => {
            if (value) {
              if (!/^.{2,30}$/.test(value)) {
                callback(new Error('请输入2-30位模板名称'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请输入模板名称'))
            }
          }}
        ],
        headRow: [
          { required: true, message: '请选择模板表头所在行', trigger: 'change' }
        ],
      },
      headRowList: [],
    }
  },
  created() {
    this.getDictionary()
  },
  methods: {
    async getDictionary() {
      const res = await baseApi.getDictionary({
        status: 1,
        type: 'TemplateHeadRow',
      });
      this.headRowList = res
      // 如果不是编辑，需要给模板表头所在行设置默认值
      if (!this.$route.query.id) {
        this.$set(this.form, 'headRow', res[0].dictionaryCode)
      }
    },
    getValidate() {
      this.changeInfo()
    },
    changeInfo() {
      this.$refs.infoForm.validate(async valid => {
        this.$emit('change', valid, this.index)
      })
    },
    changeHeadRow() {
      this.$emit('changeHeadRow', this.form.headRow)
    }
  }
}
</script>

<style lang="less" scoped>
.template-info {
  .block-icon-right {
    margin-right: 32px;
    span {
      margin: 0 10px;
    }
  }
}
</style>